<template>
    <div class="flex border-t border-b -mb-px border-gray-200 draggable" :class="getBGClass()"
         v-if="(item.status!=='OMITTED') || showOmitted ">

        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 self-start py-1.5">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"
                   v-if="canMove()"></i>
            </div>
        </div>
        <!-- Reference. -->
        <div class="w-16 flex">
            <page-cell
                ref="reference"
                v-if="canEdit()"
                class="text-sm -my-px px-2 py-1.5 border border-gray-200"
                :placeholder="'Ref...'"
                :class="((hasChanged('reference') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                v-model="reference"
                @change="addSnapshot"
                @input="update()"
            ></page-cell>
            <div v-else
                 class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative text-sm -my-px px-2 py-1.5 border border-gray-200"
                 :class="((hasChanged('reference') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
            >
                <div class="line-through text-gray-400" v-if="operationsFromExists('reference')"
                     v-text="operationsFrom('reference')"></div>
                <div :class="operationsFromExists('reference')?'font-semibold':''" v-text="reference"></div>
            </div>
        </div>
        <div class="flex flex-1">
            <div class="flex flex-col flex-1">
                <div class="flex flex-1">
                    <!-- Description. -->
                    <div class="flex-1 relative border-bottom" :key="showItemProgress?0:1"
                         :class="canEdit()?'':' flex'">
                        <div
                            v-if="!canEdit()"
                            ref="description"
                            class="whitespace-pre-line text-sm w-full -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative resize-none -mb-px"
                            :class="(showItemProgress?'mb-6 ':'') + ((hasChanged('description') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                        >
                            <div class="line-through text-gray-400" v-if="operationsFromExists('description')"
                                 v-html="highlight(operationsFrom('description'))"></div>
                            <div
                                :class="(operationsFromExists('description')?'font-semibold':'')"
                                v-html="highlight(description)"></div>
                        </div>
                        <autoresizable-textarea ref="autosizer" v-else :height="el => (el.scrollHeight + 2) + 'px'">
                <textarea
                    ref="description"
                    placeholder="Description..."
                    class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none  -mb-px"
                    :class="(showItemProgress?'mb-6 ':'') + ((hasChanged('description') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                    type="text"
                    v-model="description"
                    @change="addSnapshot"
                    @input="update()"
                    @focus="preFocusOpen = opened; opened = true; $nextTick(() => $refs.autosizer.resizer())"
                    @blur="opened = preFocusOpen"
                    rows="1"
                ></textarea>
                        </autoresizable-textarea>
                        <div class="absolute right-2 top-0 z-10 hover:z-20">
                            <ui-dropdown placement="bottom-start"
                                         menu-class="p-3 w-96 flex"
                                         class="flex w-full"
                                         trigger-class="flex w-full">
                                <template #default="{ open, close }">
                                    <div class="inline-block text-xs text-gray-400 m-0 pt-2 opacity-50">
                                        <i class="fas fa-file-import"
                                           @mouseover="open"
                                           @mouseleave="close"
                                           :class="!item.importedComponentBuildup?'opacity-0':''"></i>
                                    </div>
                                </template>
                                <template #menu>
                                    <div class="w-full text-xs"
                                         v-if="!(!item.importedComponentBuildup || !item.importedComponentBuildup.source)">
                                        Imported from :
                                        <div class="overflow-x-auto flex ">
                                            <div class="inline text-blue-500"
                                                 v-text="item.importedComponentBuildup.source.estimate.reference"></div>
                                            <div class="inline ml-2"
                                                 v-text="item.importedComponentBuildup.source.estimate.name"></div>
                                        </div>
                                        <div class="overflow-x-auto flex ml-2">
                                            <div class="inline text-blue-500"
                                                 v-text="item.importedComponentBuildup.source.section.name"></div>
                                        </div>
                                        <div class="overflow-x-auto flex ml-4">
                                            <div class="inline text-blue-500"
                                                 v-text="item.importedComponentBuildup.source.task.reference"></div>
                                            <div class="inline ml-2"
                                                 v-text="item.importedComponentBuildup.source.task.name"></div>
                                        </div>
                                        <div class="overflow-x-auto flex ml-6">
                                            <div class="inline text-blue-500"
                                                 v-text="item.importedComponentBuildup.source.item.reference"></div>
                                            <div class="inline ml-2"
                                                 v-text="item.importedComponentBuildup.source.item.name"></div>
                                        </div>
                                    </div>
                                    <div class="w-full text-sm" v-else>
                                        <div class="overflow-x-auto flex ">
                                            <div class="inline ml-2 my-4"
                                                 v-text="'No import data available'"></div>
                                        </div>
                                    </div>
                                </template>
                            </ui-dropdown>
                            <div class="inline-block text-xs text-gray-600 m-0 pt-2 opacity-25 hover:opacity-100"
                                 @click="toggleOpened">
                                <i class="fa fa-eye" :class="!canBeOpened?'opacity-0':''"></i>
                            </div>
                        </div>
                        <contracted-works-progress-line :percent="percent"
                                                        v-if="showItemProgress"></contracted-works-progress-line>
                    </div>
                    <!-- Quantity. -->
                    <div class="w-28 -ml-px flex">
                        <page-cell
                            v-if="canEdit()"
                            class="text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200"
                            :class="((hasChanged('quantity') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                            placeholder="Qty"
                            v-model="quantity"
                            @input="update()"
                            @change="addSnapshot"
                        ></page-cell>
                        <div v-else
                             class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200"
                             :class="((hasChanged('quantity') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                        >
                            <div class="line-through text-gray-400" v-if="operationsFromExists('quantity')"
                                 v-text="operationsFrom('quantity')"></div>
                            <div :class="operationsFromExists('quantity')?'font-semibold':''" v-text="quantity"></div>
                        </div>
                    </div>
                    <!-- Value. -->
                    <div class="w-28 -ml-px flex">
                        <page-cell
                            v-if="canEdit()"
                            currency
                            class="text-sm text-right -ml-px -my-px px-2 py-1.5 border border-gray-200"
                            :class="((hasChanged('value') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                            placeholder="Total"
                            v-model="value"
                            @input="update()"
                            @change="addSnapshot"
                            @blur="() => {value = item.value}"
                        ></page-cell>
                        <div v-else
                             class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative text-sm -ml-px -my-px px-2 py-1.5 border border-gray-200"
                             :class="((hasChanged('value') || (status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600':'') + (((status==='OMITTED') || proposedStatus==='OMITTED')?' line-through':'') + getBGClass()"
                        >
                            <div class="line-through text-gray-400" v-if="operationsFromExists('value')"
                                 v-text="operationsFrom('value')"></div>
                            <div :class="operationsFromExists('value')?'font-semibold':''" v-text="value"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            <ui-dropdown menu-class="p-3 w-48"
                         v-if="(!this.readonly) && (section.status!=='OMITTED') && (section.proposedStatus!=='OMITTED') && (task.status!=='OMITTED') && (task.proposedStatus!=='OMITTED')">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-trash" v-if="proposedStatus==='ADDED'" danger
                                      @click="omitItem(true); update(); close()">
                        Remove
                        addition
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-trash" v-else-if="proposedStatus!=='OMITTED'" danger
                                      @click="omitItem(true); update(); close()">Omit item
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-trash" v-else @click="omitItem(false); update(); close()">
                        Revert
                        omission
                    </ui-dropdown-item>
                    <ui-dropdown-divider v-if="hasChanged()"></ui-dropdown-divider>
                    <ui-dropdown-item icon="fas fa-undo" v-if="hasChanged()"
                                      @click="revert(); update(); close()">
                        Revert
                        changes
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>

    </div>
</template>

<script>

import ContractedWorksProgressLine from "./ContractedWorksProgressLine.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import {resolveNumericText, toCurrency} from "../../../utils";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import * as math from 'mathjs';
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";

export default {
    components: {
        AutoresizableTextarea,
        UiButtonNew, UiDropdown, UiDropdownItem, UiDropdownDivider, ContractedWorksProgressLine
    },
    props: {
        search: '',
        contractedWorks: null,
        operations: [],
        latest: Object,
        section: Object,
        task: Object,
        item: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        readonly: true,
        currentlyBuilding: false,
        currentViewing: false,
        latestProgressReport: Object,
    },
    data() {
        let oSection = null;
        if (this.latest && this.section.id === 'Preliminaries') {
            oSection = this.latest.preliminaries
        } else if (this.latest) {
            oSection = this.latest.scopeOfWorks.find((i) => i.id === this.section.id);
            oSection = oSection ? oSection.tasks : null;
        }
        let oTask = oSection ? oSection.find((i) => i.id === this.task.id) : null;
        this.item.value = toCurrency(resolveNumericText(this.item.value));
        let percent = '0%';
        if (this.latestProgressReport) {
            const os = this.latestProgressReport.sections.find((i) => i.id === this.section.id);
            const ot = (os ? os : {tasks: []}).tasks.find((i) => i.id === this.task.id);
            const oi = (ot ? ot : {items: []}).items.find((i) => i.id === this.item.id);
            percent = oi ? (math.round(parseFloat(oi.complete), 0) + '%') : '0%';
        }
        return {
            defaultReference: '1',
            reference: this.item.reference,
            description: this.item.description,
            quantity: this.item.quantity,
            value: this.item.value,
            percent: percent,
            proposedStatus: this.item.proposedStatus,
            status: this.item.status,
            original: oTask ? _.cloneDeep(oTask.items.find((i) => i.id === this.item.id)) : null,
            opened: true,
            preFocusOpen: false,
            canBeOpened: true,
            rowHeight: 34
        }
    },
    computed: {},
    methods: {
        highlight(string) {
            let lines = string.split(/\r?\n|\r|\n/g);
            lines.forEach((item, index) => {
                let textArea = document.createElement('textarea');
                textArea.innerText = item;
                lines[index] = textArea.innerHTML;
                textArea.remove();
            })
            const query = ('' + this.search).toLowerCase().split(/[^A-Za-z0-9.-]+/).filter((item) => {
                return item.trim() !== ''
            })
            if (!query.length) {
                return lines.join("\n");
            }
            let reg = new RegExp(query.join('|'), 'gi');
            return lines.join("\n").replace(reg, "<span class='bg-blue-200'>$&</span>");
        },
        operationsFromExists(type) {
            if (this.operations) {
                let op = this.operations.find((i) => (i.subject.id === this.item.id) && (i.subject.type === 'Item') && (i.type === 'Substitution'));
                if (op) {
                    let prop = op.value[type]
                    return (typeof prop !== 'undefined' && prop !== null)
                }
            }
            return false;
        },
        operationsFrom(type) {
            if (this.operations) {
                let op = this.operations.find((i) => (i.subject.id === this.item.id) && (i.subject.type === 'Item') && (i.type === 'Substitution'));
                return op.value[type].from ? op.value[type].from : '<blank>'
            }
            return '<blank>';
        },
        showBuildUp() {
            this.$emit('editBuildup', this.item)
        },
        canEdit() {
            return (!this.readonly) && (this.proposedStatus !== 'OMITTED') && (this.status !== 'OMITTED') && (this.section.status !== 'OMITTED') && (this.section.proposedStatus !== 'OMITTED') && (this.task.status !== 'OMITTED') && (this.task.proposedStatus !== 'OMITTED')
        },
        canMove() {
            return (!this.readonly) && (this.proposedStatus === 'ADDED');
        },
        omitItem(omitted) {
            if (this.proposedStatus === 'ADDED') {
                this.task.items.splice(this.task.items.indexOf(this.item), 1)
            } else {
                this.revert()
                if (omitted) {
                    this.proposedStatus = 'OMITTED'
                } else {
                    this.proposedStatus = null;
                }
            }
            this.addSnapshot();
        },
        updateState() {
            if (this.hasChanged() && !this.proposedStatus) {
                this.proposedStatus = 'SUBSTITUTED'
            }
            if ((this.proposedStatus === 'SUBSTITUTED') && !this.hasChanged()) {
                this.proposedStatus = false
            }
            let v = parseFloat(this.value ? (this.value.replace(/[^\d.-]/g, '')) : 0);
            this.item.reference = this.reference
            this.item.description = this.description
            this.item.value = toCurrency(v ? v : 0)
            this.item.quantity = this.quantity
            this.item.proposedStatus = this.proposedStatus
        },
        update(snapshot) {
            this.updateState()
            this.$emit('updated', snapshot)
        },
        addSnapshot() {
            this.updateState()
            this.$emit('updated', true)
        },
        revert() {
            if (this.hasChanged()) {
                this.item.reference = this.original.reference
                this.reference = this.item.reference
                this.item.description = this.original.description
                this.description = this.item.description
                this.item.quantity = this.original.quantity
                this.quantity = this.item.quantity
                this.item.value = this.original.value
                this.value = this.item.value
                this.item.importedComponentBuildup = _.cloneDeep(this.original.importedComponentBuildup)
                this.addSnapshot();
            }
            this.proposedStatus = null
        },
        hasChanged(field = false) {
            if (!field) {
                return (this.original && (
                    (this.reference !== this.original.reference)
                    ||
                    (this.description !== this.original.description)
                    ||
                    (this.quantity !== this.original.quantity)
                    ||
                    (resolveNumericText(this.value) !== resolveNumericText(this.original.value))
                ))
            }
            if (field === 'value') {
                return (this.original && (resolveNumericText(this[field]) !== resolveNumericText(this.original[field])))
            } else {
                return (this.original && (this[field] !== this.original[field]))
            }
        },
        getBGClass() {
            if (this.proposedStatus === 'OMITTED') {
                return ' bg-red-50';
            }
            if (this.proposedStatus === 'ADDED') {
                return ' bg-green-50';
            }
            if (this.hasChanged() || (this.proposedStatus === 'SUBSTITUTED')) {
                return ' bg-orange-50'
            }
            return ' bg-white';
        },
        toggleOpened() {
            this.opened = !this.opened;
        },
    },
    mounted() {
        this.opened = false;
        this.$nextTick(() => {
            if (this.$refs.description) {
                this.canBeOpened = this.$refs.description.scrollHeight > this.$refs.description.getBoundingClientRect().height + 6
                this.rowHeight = math.ceil(this.$el.getBoundingClientRect().height);
            }
        })

    }
}
</script>
